import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllTemplatesExchangeList: [],
  getTemplatesExchangeById: [],
  isLoading: false,
  getAllDotPhraseList: [],
  getDotPhraseByIdList: [],
  getInsightHealthTemplatesList: [],
  getInsightHealthTemplatesById: [],
  templateExchangeCount: {},
};

const templatesExchangeSlice = createSlice({
  name: 'templatesExchangeSlice',
  initialState,
  reducers: {
    getAllTemplatesExchangeListSlice: (state, { payload }) => {
      state.getAllTemplatesExchangeList = payload;
    },
    getTemplatesExchangeByIdSlice: (state, { payload }) => {
      state.getTemplatesExchangeById = payload;
    },
    templatesExchangeSlice: (state, { payload }) => {
      state.isLoading = payload;
    },
    getAllDotPhraseExchangeListSlice: (state, { payload }) => {
      state.getAllDotPhraseList = payload;
    },
    getDotPhraseByIdListSlice: (state, { payload }) => {
      state.getDotPhraseByIdList = payload;
    },
    getInsightHealthTemplatesListSlice: (state, { payload }) => {
      state.getInsightHealthTemplatesList = payload;
    },
    getInsightHealthTemplatesByIdSlice: (state, { payload }) => {
      state.getInsightHealthTemplatesById = payload;
    },
    getTemplateExchangeCountSlice: (state, { payload }) => {
      state.templateExchangeCount = payload;
    },
  },
});

const { actions, reducer } = templatesExchangeSlice;

export const {
  getAllTemplatesExchangeListSlice,
  getTemplatesExchangeByIdSlice,
  getAllDotPhraseExchangeListSlice,
  getDotPhraseByIdListSlice,
  getInsightHealthTemplatesListSlice,
  getInsightHealthTemplatesByIdSlice,
  getTemplateExchangeCountSlice,
} = actions;

export default reducer;
